


























import { Component, Vue } from 'vue-property-decorator'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { httpsImg } from '@/utils/tool'
import { userNew } from '@/api/home'

import { userLogo } from '../types'

@Component({
  name: 'NewBusi',
  components: {
    swiper: Swiper,
    'swiper-slide': SwiperSlide
  },
  directives: {
    swiper: directive
  }
})
export default class NewBusi extends Vue {
  private swiperOptions = {
    loopedSlides: 6,
    slidesPerView: 'auto', // 显示数量
    spaceBetween: 10,
    observer: true, // 修改swiper自己或子元素时，自动初始化swiper
    observeParents: true, // 修改swiper的父元素时，自动初始化swiper
    // loop: true, // 循环模式选项
    speed: 1000,
    autoplay: {
      delay: 1000,
      stopOnLastSlide: false,
      disableOnInteraction: false
    },
    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  }

  // 新进商户
  private userNewList: any[] = []

  private httpsImg = httpsImg

  // 新进商户
  private getUserNew (): void {
    userNew()
      .then((res: any) => {
        if (res) {
          this.userNewList = res
        }
      })
  }

  // 点击某一个商户
  private clickItem (item: userLogo): void {
    console.log(item)
    this.$router.push(`/business/merchant/${item.dbLink}/${item.parentMchId}`)
  }

  mounted ():void {
    this.getUserNew()
  }
}
